import { Injectable } from '@angular/core';
import { NbToastrService, NbGlobalPhysicalPosition, NbComponentStatus } from '@nebular/theme';
import { HttpService } from './common/http.service';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  constructor(private toastr: NbToastrService, private api: HttpService) {}

  showLeaveApproved(employeeName: string, leaveRange?: string) {
    const status: NbComponentStatus = 'success';
    const title = 'Leave Approved';
    const message = leaveRange
      ? `${employeeName}'s leave (${leaveRange}) has been approved.`
      : `${employeeName}'s leave has been approved.`;

    this.toastr.show(message, title, {
      status,
      duration: 5000,
      destroyByClick: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
    });
  }

  /**
   * Show a local toast and attempt to create a server-side notification record.
   * The server endpoint `/notifications` is optional — failure is non-fatal.
   */
  notifyEmployeeOfLeaveApproval(employeeDocumentId: string | undefined, employeeName: string, leaveRange?: string): void {
    // Show local toast first
    this.showLeaveApproved(employeeName, leaveRange);

    if (!employeeDocumentId) return;

    const title = 'Leave Approved';
    const message = leaveRange
      ? `${employeeName}'s leave (${leaveRange}) has been approved.`
      : `${employeeName}'s leave has been approved.`;

    // Try to create a backend notification (non-blocking)
    try {
      this.api.post('notifications', {
        data: {
          recipient: employeeDocumentId,
          title,
          message,
          category: 'leave',
          metadata: { leaveRange },
        },
      }).subscribe({ next: () => {}, error: () => {} });
    } catch (e) {
      // ignore errors — toast already shown
    }
  }
}